import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  // Google Analytics account tracking ID
  private trackingId: string;

  // Google Analytics library URL
  private gtagUrl: string;

  // Current page of the application
  private currentPage: string;

  constructor() {
    // Gets the tracking ID from environment file
    this.trackingId = environment && environment.gtagTrackingId;

    // Gets the gtag URL from environment file
    this.gtagUrl = environment && environment.gtagUrl;
    this.gtagUrl += this.trackingId;

    this.currentPage = '';
  }

  // Adds the script tag with gtag configuration in head tag
  init(): void {
    const scriptFunction = document.createElement('script');
    scriptFunction.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());`;
    document.head.prepend(scriptFunction);

    const scriptUrl = document.createElement('script');
    scriptUrl.async = true;
    scriptUrl.src = this.gtagUrl;
    document.head.prepend(scriptUrl);

  }

  /**
   * Starts tracking URL after redirection once route navigation ends
   * @param url The URL after redirection captured from Router NavigationEnd API
   */
  startTrackingNavigation(url: string): void {
    this.currentPage = url ? url.split('/').join(' > ').substr(3).toUpperCase() : '';
    gtag('config', this.trackingId,
      {
        'page_path': url
      }
    );
  }

  // Returns application's current page
  getCurrentApplicationPage(): string {
    return this.currentPage;
  }

  /**
   * Tracks current page events
   * @param event Event from page interactions, Click & Scroll
   * @param label Clicked/Focused sub section of the page
   */
  trackPageEvents(event: string, label: string): void {
    gtag('event', event, {
      'event_category': this.getCurrentApplicationPage(),
      'event_label': label
    });
  }
}
